import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { /* dispatchSetCurrentEmployee, */ setCurrentEmployee } from '../../employment/employment-slice';
import { Employee } from '../../employment/employment-model';
import { getEmployments } from '../../../../../global/ducks/benadmin-api';
import { GetEmploymentsAndCompensations } from '../../employment-compensation/employment-compensation-requests';

export function useGetCurrentEmployeeFromEmployeeList() {
	const dispatch = useDispatch();

    const employeeGuid =  useSelector<TcsmStates, string>(state => state?.employmentState?.currentEmployee?.guid);
    const initialList = useSelector<TcsmStates, Employee[]>(state => state.employmentState.employeeList);


    const match = initialList.filter(x => x.guid === employeeGuid)[0];

    useEffect(() => {
        if (match) {            
            dispatch(setCurrentEmployee(match));
            dispatch(getEmployments(
                employeeGuid,
                (response) => GetEmploymentsAndCompensations(dispatch, response),
            ));
        }
    }, [match]);

	return match;
}